import React  from 'react'
import { Box, Text, Flex } from '@chakra-ui/react'
import IbBadge from 'components/common/IbBadge'
import { PenTool, User, Clock, XCircle, CheckCircle } from 'react-feather'
import { IDashboardCollaborator } from 'services/IApi.d'

interface Props {
  data: IDashboardCollaborator | any
}

const Badge = ({ color, children }) => (
  <Box display='inline-block'>
    <Flex color={color} justifyContent='left' gap='5px' alignItems='center'>
      {children}
    </Flex>
  </Box>
)

const status = {
  'CONFIRMADO':
    <Badge color='success.500'>
      <CheckCircle size='18px' /> <Text textStyle='bodySm'> Solicitud confirmada </Text>
    </Badge>,
  'PENDIENTE_CONFIRMACION':
    <Badge color='warning.500'>
      <Clock size='18px' /> <Text textStyle='bodySm'> Debe confirmar la solicitud</Text>
    </Badge>,
  'EXPIRADO':
    <Badge color='warning.500'>
      <Clock size='18px' /> <Text textStyle='bodySm'> Debe confirmar la solicitud</Text>
    </Badge>,
  'NO_CONFIRMADO':
    <Badge color='destructive.400'>
      <XCircle size='18px' /> <Text textStyle='bodySm'> No confirmó la solicitud </Text>
    </Badge>,
}

const renderRoles = (roles: number[]) => (
  roles.map((role, indexRole) => (
    <Box display='inline-block' data-testid={`collaborator-badge-${indexRole}`} key={role}>
      <IbBadge variant='brand-dark' fontSize='12px' borderRadius='2xl' py={1}>
        {+role === 1 ?
          <><PenTool size='18px' /> Administrador</>
          :
          <><User size='18px' /> Representante</>
        }
      </IbBadge>
    </Box>
  )))

const CollaboratorsResume: React.FunctionComponent<Props> = ({ data = [] }) => (
  data.map((colaborador: IDashboardCollaborator) => {
    const { id: idColaborador, name: nombre, lastName: apellido, role: rol, confirmed: confirmado, isSubscriptor: esSuscriptor } = colaborador
    return (
      <Box key={idColaborador}>
        <Flex justifyContent='left' gap='10px' alignItems='center' mb='4'>
          <Text>{nombre} {apellido} {esSuscriptor && '(vos)'}</Text>
          {renderRoles(rol)} {rol.includes(2) && status[confirmado]}
        </Flex>
      </Box>
    )
  })
)

export default CollaboratorsResume
